import * as React from "react";
import { Link, useNavigate } from "react-router";
import { Button } from "primereact/button";

import { constantMessage } from "../../../helpers/constants";
import { useKeycloak } from "../../../contexts/KeycloakContext";


export const UnAuthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { authenticated, login } = useKeycloak();

  React.useEffect(() => {
    if (authenticated) {
      navigate('/');
    }
  }, [authenticated, navigate]);

    
  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex flex-column align-items-center">
          <h1>{constantMessage.unAuthorizedMessage}</h1>
          <div className="mt-3">
            <Button label="Войти" icon="pi pi-sign-in" onClick={login} />
            <Link className="btn btn-link ml-2" to="/registration">Зарегистрироваться</Link>
          </div>
        </div>
      </div>
    </div>
  );
};
    